import React from "react";
import {fetchGallery} from "../reducers/galleries";
import SeoComponent from "../common/SeoComponent";
import LayoutComponent from "../common/LayoutComponent";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {getByAlias} from '../selectors/common';
import {Route, Switch} from "react-router-dom";
import NotFound from "./NotFound";

class Gallery extends SeoComponent {
    static fetchData(store, params) {
        return store.dispatch(fetchGallery(params.alias));
    }

    componentDidMount() {
        if (this.props.gallery === null) {
            this.props.fetchGallery(this.props.match.params.alias);
        }
    }

    render() {
        let content;
        if (this.props.notFound) {
            return <Switch>
                <Route component={NotFound}/>
            </Switch>
        } else if (this.props.error) {
            content = <div>Не удалось получить данные с сервера</div>
        } else if (this.props.loading || this.props.gallery === null) {
            content = <div>Loading</div>
        } else {
            this.setMetaTags(this.props.gallery.title);
            content = this.props.gallery.title;
        }

        return <LayoutComponent routerMatch={this.props.match}>
            {content}
        </LayoutComponent>
    }
}

const mapStateToProps = (state, props) => {
    return {
        gallery: getByAlias(state.galleries.items, props.match.params.alias),
        error: state.galleries.error,
        loading: state.galleries.loading,
        notFound: state.galleries.notFound,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({fetchGallery}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Gallery);


// WEBPACK FOOTER //
// ./src/js/components/Gallery.js